import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { locales } from "../../locales";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    // y: {
    //   ticks: {
    //     // Include the "%" sign after the number
    //     callback: function (value, index, values) {
    //       return value + "%";
    //     },
    //   },
    // },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          var label = context.dataset.label || "";

          if (label) {
            label += ": ";
          }
          if (context.parsed.y !== null) {
            label += context.parsed.y + "%";
          }
          return label;
        },
      },
    },
  },
};

function Percentage({ data, langId }) {
  const labels = data.map((item) =>
    item.party === "FRÄI LËSCHT - ÄR LEIT FIR ROUSPERT-MOMPECH"
      ? "FRÄI LËSCHT - ÄR LEIT"
      : item.party
  );
  const dataObj = data.map((item) => item.percentage);

  // Find max percentage
  const maxPercentage = Math.max(...dataObj);

  const backgroundColors = dataObj.map((value) =>
    value === maxPercentage ? "#E88B00" : "#86CDEB"
  );

  const chartData = {
    labels,
    datasets: [
      {
        label: locales[langId].votesPercentage,
        data: dataObj,
        backgroundColor: backgroundColors,
      },
    ],
  };

  return <Bar options={options} data={chartData} />;
}

export default Percentage;
